export enum IndicationIdentifierEnum {
    AMD = 'AMD',
    DMO = 'DMO',
    RVE = 'RVE',
    BASIC = 'BASIC',
    TRIEMLI = 'TRIEMLI'
}

